(function(){
  const $ = s => document.querySelector(s), $$ = s => document.querySelectorAll(s);
  const root = document.documentElement;
  const set = (sel, t) => $$(sel).forEach(e => { e.textContent = t; });
  const money = (() => {
    // Follows the active Shopify Markets currency: window.BettrMoney is a sample amount (12,345.67) rendered by Liquid's money filter.
    const ta = document.createElement('textarea'); ta.innerHTML = window.BettrMoney || 'RM12,345.67';
    const m = ta.value.trim().match(/^(.*?)(\d[\d.,'\s\u00a0\u202f]*\d)(.*)$/) || [0, 'RM', '12,345.67', ''];
    const num = m[2], dm = num.match(/([.,])\d{2}$/), dec = dm ? dm[1] : '';
    const th = /\d/.test(num.charAt(2)) ? '' : num.charAt(2);
    return c => { const s = dec ? (c / 100).toFixed(2) : String(Math.round(c / 100)); const p = s.split('.'); return m[1] + p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th) + (dec ? dec + p[1] : '') + m[3]; };
  })();
  let flavor = 'Peach Mango', plan = 'sub', qty = 1;

  const mainImg = $('#mainImg');
  function setImage(src){
    if (mainImg && mainImg.getAttribute('src') !== src){ mainImg.style.opacity = 0; setTimeout(() => { mainImg.src = src; mainImg.style.opacity = 1; }, 140); }
    $$('#thumbs button').forEach(b => b.setAttribute('aria-pressed', b.dataset.src === src ? 'true' : 'false'));
  }
  $$('#thumbs button').forEach(b => b.addEventListener('click', () => setImage(b.dataset.src)));

  // ---- product data ----
  let P = null; try { P = JSON.parse(($('#bettrProduct') || {}).textContent || 'null'); } catch(e){}
  const opts = P ? P.options.map(o => String(o).toLowerCase()) : [];
  const fi = Math.max(0, opts.findIndex(o => /flav/.test(o)));
  const si = opts.findIndex((o, i) => i !== fi && /size|pack|bag|qty|quantity/.test(o));
  const twoBag = v => si < 0 ? false : /2|two|30|bundle/i.test(v.options[si]);
  const find = (fl, two) => P && P.variants.find(v => String(v.options[fi]).toLowerCase() === fl.toLowerCase() && (si < 0 || twoBag(v) === two));
  // No product linked yet (e.g. homepage before the product exists): show the launch prices so the buy box still reads correctly.
  const DEMO = {sub: 16770, bundle: 19900, once: 12900};
  if (!P){ const bf = $('#buyForm'); if (bf) bf.addEventListener('submit', e => { e.preventDefault(); const n = $('[data-buy-note]'); if (n){ n.hidden = false; n.textContent = 'Checkout switches on once the Bettr. Daily Fiber product is added in Shopify.'; } }); }
  function choice(pl){
    if (!P) return {v: {id: '', available: true}, mult: 1, sp: null, price: DEMO[pl], compare: pl === 'once' ? 0 : 25800, sachets: pl === 'once' ? 15 : 30};
    // sub: 2 bags + first selling plan; bundle: 2 bags; once: 1 bag. Without a Size option, 2 bags = quantity x2.
    const v = find(flavor, si >= 0 && pl !== 'once'); if (!v) return null;
    const mult = (si < 0 && pl !== 'once') ? 2 : 1;
    const sp = pl === 'sub' ? v.plans[0] : null;
    if (pl === 'sub' && !sp) return null;
    return {v, mult, sp, price: (sp ? sp.price : v.price) * mult, compare: (v.compare || 0) * mult, sachets: 15 * (pl === 'once' ? 1 : 2)};
  }
  function paint(){
    // If the selected plan is not set up on the product (e.g. no subscription plan yet), fall back to the first one that is.
    if (!choice(plan)){ const alt = ['sub', 'bundle', 'once'].find(p => choice(p)); if (alt){ plan = alt; const r = $('input[name="plan"][value="' + alt + '"]'); if (r) r.checked = true; } }
    ['sub', 'bundle', 'once'].forEach(pl => {
      const c = choice(pl), lab = $('[data-plan="' + pl + '"]');
      if (lab) lab.hidden = !c;
      if (!c) return;
      set('[data-p-' + pl + ']', money(c.price));
      set('[data-day-' + pl + ']', money(c.price / c.sachets) + ' / day');
      set('[data-save-' + pl + ']', c.compare > c.price ? 'You save ' + money(c.compare - c.price) + ' (' + Math.round(100 - c.price / c.compare * 100) + '%)' : '');
      $$('[data-cmp-' + pl + ']').forEach(e => { e.hidden = !(c.compare > c.price); e.textContent = money(c.compare); });
      if (pl === 'sub'){ const r = $('[data-ribbon]'); if (r){ r.hidden = !(c.compare > c.price); r.textContent = 'Most popular · save ' + Math.round(100 - c.price / c.compare * 100) + '%'; } }
    });
    if (!choice(plan)){ plan = ['sub', 'bundle', 'once'].find(pl => choice(pl)) || plan; const r = $('input[name="plan"][value="' + plan + '"]'); if (r) r.checked = true; }
    $$('[data-plan]').forEach(l => l.classList.toggle('active', l.dataset.plan === plan));
    set('[data-qty]', qty);
    const c = choice(plan), btn = $('[data-add]'), note = $('[data-buy-note]');
    if (!btn) return;
    if (!c || !c.v.available){
      btn.disabled = true; set('[data-price]', c ? 'sold out' : 'unavailable');
      if (note){ note.hidden = !!c; note.textContent = 'This flavour or option is not set up on the product yet.'; }
      return;
    }
    btn.disabled = false; if (note) note.hidden = true;
    set('[data-price]', money(c.price * qty));
    $('[data-variant-input]').value = c.v.id;
    $('[data-qty-input]').value = qty * c.mult;
    const pi = $('[data-plan-input]'); pi.disabled = !c.sp; pi.value = c.sp ? c.sp.id : '';
  }
  $$('input[name="plan"]').forEach(r => r.addEventListener('change', e => { plan = e.target.value; paint(); }));
  const qp = $('#qPlus'), qm = $('#qMinus');
  if (qp) qp.addEventListener('click', () => { qty = Math.min(6, qty + 1); paint(); });
  if (qm) qm.addEventListener('click', () => { qty = Math.max(1, qty - 1); paint(); });

  function pick(c, go){
    flavor = c.dataset.f;
    $$('.fl').forEach(x => x.setAttribute('aria-pressed', x.dataset.f === flavor ? 'true' : 'false'));
    root.style.setProperty('--flavor', 'var(' + c.dataset.c + ')');
    set('[data-flavor-name]', flavor);
    const tf = $('#thumbFlavor'); if (tf){ tf.dataset.src = c.dataset.src; tf.querySelector('img').src = c.dataset.src; }
    setImage(c.dataset.src); paint();
    if (go){ const b = $('#buy'); if (b) b.scrollIntoView(); }
  }
  $$('.fl').forEach(c => c.addEventListener('click', () => pick(c, c.closest('#flavs'))));
  const want = new URLSearchParams(location.search).get('flavour');
  const start = want && [...$$('.fl')].find(c => c.dataset.f.toLowerCase() === want.toLowerCase());
  if (start) pick(start, false); else paint();

  const fl = $('#filters');
  if (fl) fl.querySelectorAll('button').forEach(b => b.addEventListener('click', () => {
    fl.querySelectorAll('button').forEach(x => x.setAttribute('aria-pressed', 'false')); b.setAttribute('aria-pressed', 'true');
  }));
  const dlg = $('#labelDlg');
  if (dlg){
    $$('#labelBtn,[data-label]').forEach(b => b.addEventListener('click', () => { if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', ''); }));
    const x = $('#dlgClose'); if (x) x.addEventListener('click', () => dlg.close ? dlg.close() : dlg.removeAttribute('open'));
    dlg.addEventListener('click', e => { if (e.target === dlg) dlg.close(); });
  }

  // ---- polish pass: footer flavour links, mobile menu, sticky mobile buy bar ----
  $$('[data-pick]').forEach(a => a.addEventListener('click', e => {
    const c = [...$$('.fl')].find(x => x.dataset.f === a.dataset.pick), b = $('#buy');
    if (c && b){ e.preventDefault(); pick(c, false); b.scrollIntoView(); }
  }));
  const mn = $('.mnav');
  if (mn){
    mn.querySelectorAll('a').forEach(a => a.addEventListener('click', () => mn.removeAttribute('open')));
    document.addEventListener('click', e => { if (mn.open && !mn.contains(e.target)) mn.removeAttribute('open'); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') mn.removeAttribute('open'); });
  }
  const mbar = $('[data-mbar]'), buyEl = $('#buy');
  if (mbar && buyEl && 'IntersectionObserver' in window){
    let inBuy = false, inFoot = false; const foot = $('footer');
    const upd = () => { const on = buyEl.getBoundingClientRect().bottom < 0 && !inFoot; mbar.classList.toggle('on', on); root.style.setProperty('--toast-lift', on ? '92px' : '22px'); };
    const io = new IntersectionObserver(es => { es.forEach(e => { if (e.target === buyEl) inBuy = e.isIntersecting; else inFoot = e.isIntersecting; }); upd(); });
    io.observe(buyEl); if (foot) io.observe(foot);
    window.addEventListener('scroll', upd, {passive: true}); upd();
  }

  // ---- cart drawer ----
  const cd = $('#cartDrawer');
  if (cd){
    const R = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    const cbody = $('[data-cd-body]'), cfoot = $('[data-cd-foot]'), panel = cd.querySelector('.cd-panel');
    const esc = s => String(s == null ? '' : s).replace(/[&<>"]/g, c => ({'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;'}[c]));
    let lastFocus = null, busy = false;
    const render = cart => {
      set('[data-cart]', cart.item_count);
      if (!cart.items.length){ cbody.innerHTML = '<p class="cd-empty">Your cart is empty.</p><a class="btn" href="#buy" data-cd-close>Shop Bettr. Daily Fiber</a>'; cfoot.hidden = true; return; }
      cbody.innerHTML = cart.items.map((it, i) => {
        const sub = [it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title.split(' / ').join(' · ') : '', it.selling_plan_allocation ? 'Subscription · delivered every month' : ''].filter(Boolean);
        const img = it.image ? '<img src="' + esc(it.image) + (it.image.indexOf('?') < 0 ? '?' : '&') + 'width=160" alt="" width="76" height="76" loading="lazy">' : '<span></span>';
        return '<div class="cd-item">' + img + '<div><strong>' + esc(it.product_title) + '</strong>' + sub.map(s => '<small>' + esc(s) + '</small>').join('') +
          '<div class="cd-q"><button type="button" data-cd-qty="' + (i + 1) + '|' + (it.quantity - 1) + '" aria-label="Decrease quantity">−</button><span>' + it.quantity + '</span><button type="button" data-cd-qty="' + (i + 1) + '|' + (it.quantity + 1) + '" aria-label="Increase quantity">+</button></div></div>' +
          '<div class="cd-side"><div class="cd-price">' + money(it.final_line_price) + '</div><button type="button" class="cd-rm" data-cd-qty="' + (i + 1) + '|0">Remove</button></div></div>';
      }).join('');
      cfoot.hidden = false; set('[data-cd-total]', money(cart.total_price));
    };
    const load = () => fetch(R + 'cart.js', {headers: {accept: 'application/json'}}).then(r => r.json()).then(render);
    const change = (line, quantity) => {
      if (busy) return; busy = true; cd.classList.add('busy');
      fetch(R + 'cart/change.js', {method: 'POST', headers: {'content-type': 'application/json', accept: 'application/json'}, body: JSON.stringify({line, quantity})})
        .then(r => r.json()).then(c => c.items ? render(c) : load()).catch(load).finally(() => { busy = false; cd.classList.remove('busy'); });
    };
    const openCart = () => { lastFocus = document.activeElement; cd.hidden = false; requestAnimationFrame(() => cd.classList.add('on')); root.classList.add('cd-lock'); panel.focus(); };
    const closeCart = () => { cd.classList.remove('on'); root.classList.remove('cd-lock'); setTimeout(() => { if (!cd.classList.contains('on')) cd.hidden = true; }, 260); if (lastFocus && lastFocus.focus) lastFocus.focus(); };
    cd.addEventListener('click', e => {
      const t = e.target.closest('[data-cd-close],[data-cd-qty]'); if (!t) return;
      if (t.hasAttribute('data-cd-qty')){ const a = t.dataset.cdQty.split('|'); change(+a[0], +a[1]); } else closeCart();
    });
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && !cd.hidden) closeCart(); });
    $$('a.cart').forEach(a => a.addEventListener('click', e => { e.preventDefault(); openCart(); load(); }));
    const bform = $('#buyForm');
    if (bform && P) bform.addEventListener('submit', e => {
      e.preventDefault(); const btn = $('[data-add]'), note = $('[data-buy-note]'); if (!btn || btn.disabled) return; btn.disabled = true; if (note) note.hidden = true;
      fetch(R + 'cart/add.js', {method: 'POST', headers: {accept: 'application/json'}, body: new FormData(bform)})
        .then(r => r.json().then(d => r.ok ? d : Promise.reject(d)))
        .then(() => { openCart(); return load(); })
        .catch(err => { if (note){ note.hidden = false; note.textContent = (err && err.description) || 'Could not add to cart. Please try again.'; } })
        .finally(() => { btn.disabled = false; });
    });
  }

  // ---- sticky add to cart: mirrors the main button ----
  const sb = $('[data-add-sticky]'), mb0 = $('[data-add]');
  if (sb && mb0){
    const names = {sub: 'Subscribe & save', bundle: '30-day bundle', once: 'Trial pack'};
    const sync = () => { sb.disabled = mb0.disabled; const r = $('input[name="plan"]:checked'); set('[data-plan-name]', r ? names[r.value] : ''); };
    new MutationObserver(sync).observe(mb0, {attributes: true, attributeFilter: ['disabled']});
    $$('input[name="plan"]').forEach(r => r.addEventListener('change', sync)); sync();
  }

  // ---- back to top (mobile) ----
  const tt = $('[data-totop]');
  if (tt){
    const tu = () => tt.classList.toggle('on', window.scrollY > 900);
    window.addEventListener('scroll', tu, {passive: true}); tu();
    tt.addEventListener('click', () => window.scrollTo({top: 0, behavior: 'smooth'}));
  }
})();
